import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "1:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/mode-by-mode/pressure-modulus-x0-1-mode.png`,
        },
      },
    },
  },
};

export default components;
